/* eslint-disable i18next/no-literal-string */

import { useGlobalSearchParams, usePathname } from 'expo-router'
import { Suspense, useEffect } from 'react'
import { usePostHog } from '~/lib/analytics/posthog'

function PostHogPageView(): null {
  const pathname = usePathname()
  const params = useGlobalSearchParams()
  const posthog = usePostHog()

  // Track pageviews
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname
      if (params.toString()) {
        url = `${url}?${params.toString()}`
      }

      posthog.capture('$pageview', { $current_url: url })
    }
  }, [pathname, params, posthog])

  return null
}

// Wrap this in Suspense to avoid the `useSearchParams` usage above
// from de-opting the whole app into client-side rendering
// See: https://nextjs.org/docs/messages/deopted-into-client-rendering
export default function SuspendedPostHogPageView() {
  return (
    <Suspense fallback={null}>
      <PostHogPageView />
    </Suspense>
  )
}
